import { useState } from "react";

import { put } from "../../rest_client";

import * as styles from "./CreaTerms.styles";

interface Props {
  onAccepted: () => void;
}

const CREATerms = ({ onAccepted }: Props) => {
  const [accepted, setAccepted] = useState(false);
  const [rejected, setRejected] = useState(false);

  const handleTermsAccepted = () => {
    put(
      "/accept_terms",
      {},
      () => {
        setAccepted(true);
        onAccepted();
      },
      () => {
        window.alert(
          "An error occured while accepting terms. Please refresh the page and try again.",
        );
      },
    );
  };

  const renderTerms = () => {
    if (!accepted && !rejected) {
      return (
        <div css={styles.creaTerms}>
          <h3>To view the listings</h3>
          <h4>Please accept the following terms</h4>
          <div css={styles.terms}>
            <p css={styles.termsSection}>
              1) REALTOR®, REALTORS®, and the REALTOR® logo are certification marks that are
              owned by REALTOR® Canada Inc. and licensed exclusively to The Canadian Real Estate
              Association(CREA). These certification marks identify real estate professionals who
              are members of CREA and who must abide by CREA’s By - Laws, Rules, and the REALTOR®
              Code. The MLS® trademark and the MLS® logo are owned by CREA and identify the
              quality of services provided by real estate professionals who are members of CREA.
            </p>
            <p css={styles.termsSection}>
              2) The information contained on this site is based in whole or in part on information
              that is provided by members of The Canadian Real Estate Association, who are
              responsible for its accuracy. CREA reproduces and distributes this information as a
              service for its members and assumes no responsibility for its accuracy
            </p>
            <p css={styles.termsSection}>
              3) This website is operated by Exsellence Team Realty Inc. Brokerage who is a member
              of The Canadian Real Estate Association.
            </p>
            <p css={styles.termsSection}>
              4) The listing content on this website is protected by copyright and other laws, and
              is intended solely for the private, non - commercial use by individuals. Any other
              reproduction, distribution or use of the content, in whole or in part, is specifically
              forbidden. The prohibited uses include commercial use, “screen scraping”, “database
              scraping”, and any other activity intended to collect, store, reorganize or manipulate
              data on the pages produced by or displayed on this website.
            </p>
          </div>

          <div>
            <button css={styles.btn} className="btn btn-small" onClick={handleTermsAccepted}>
              Accept Terms
            </button>
            <button className="btn btn-small btn-secondary" onClick={() => setRejected(true)}>
              Decline
            </button>
          </div>
        </div>
      );
    }
  };

  const renderRejectedMessage = () => {
    if (!rejected) return;

    return (
      <div css={styles.creaTerms}>
        To view listings, you need to accept the CREA terms. To reload the terms, please reload the
        page.
      </div>
    );
  };

  return (
    <>
      {renderTerms()}
      {renderRejectedMessage()}
    </>
  );
};

export { CREATerms };
